"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combine = exports.sum = void 0;
function sum(values, key) {
    if (key === undefined) {
        return values.reduce((a, b) => a + b, 0);
    }
    return values.reduce((acc, value) => acc + (value[key] ?? 0), 0);
}
exports.sum = sum;
function combine(values, identity, add) {
    return values.reduce((acc, v) => add(acc, v), identity);
}
exports.combine = combine;
//# sourceMappingURL=sum.js.map